import React from 'react';
import { render } from 'react-dom';
import Router from './Router';
import './css/styles.css';


render(<Router />, document.getElementById('main'));